export default __webpack_public_path__ + "static/media/border-cap-round-17.db680255.svg";